import React from 'react'
import PropTypes from 'prop-types'
import Loader from 'react-loader-spinner'
import {connect} from 'react-redux'

const Loaders = ({stateLoading}) => (
  <React.Fragment>
    {stateLoading && <div className="loader">
      <Loader
        type='Oval'
        color='#6aae5b'
        height={100}
        width={100}
      />
    </div>}
  </React.Fragment>
)


Loaders.propTypes = {
  stateLoading: PropTypes.bool.isRequired,
}

const mapStateToProps = state => ({
  stateLoading: state.stateLoader.loading
})
export default connect(mapStateToProps)(Loaders)